import { inventarioService } from '@/services'

export default {
  namespaced: true,
  state: {
    estado: null,
    page: 1,
    pageSize: 10,
    recuento: null,
    totalItems: 0,
    items: [],
    folios: [],
    scrollX: {
      scrollLeft: 0,
      source: null
    },
    pageSizes: [10, 25, 50, 100],
    busquedaFolio: '',
    busquedaArticulo: ''
  },
  getters: {
    estaAbierto: (state) =>
      state.recuento && state.recuento.estado === 'Abierto',
    items: (state) => state.items,
    folios: (state) => state.folios,
    metadata: (state) => ({
      page: state.page,
      pageSize: state.pageSize,
      totalItems: state.totalItems,
      pageSizes: state.pageSizes,
      busquedaFolio: state.busquedaFolio,
      busquedaArticulo: state.busquedaArticulo
    }),
    scrollX: (state) => state.scrollX
  },
  mutations: {
    INITIAL_DATA_REQUEST: (state) => {
      state.estado = 'loading'
    },
    DATA_REQUEST: (state) => {
      state.estado = 'loading'
    },
    DATA_SUCCESS: (state) => {
      state.estado = 'ok'
    },
    RECUENTO_REQUEST: (state) => {
      state.recuento = null
      state.estado = 'loading'
    },
    RECUENTO_SUCCESS: (state, payload) => {
      state.recuento = payload
    },
    ITEMS_REQUEST: (state) => {
      state.estado = 'loading'
    },
    ITEMS_SUCCESS: (state, payload) => {
      state.items = [...payload]
    },
    FOLIOS_REQUEST: (state) => {
      state.estado = 'loading'
    },
    FOLIOS_SUCCESS: (state, payload) => {
      const cuenta = new Map()
      payload.forEach((folio) => {
        // Sumar cantidad contada
        folio.items
          .filter((item) => item.confirmado)
          .forEach((item) => {
            const index = state.items.findIndex(
              (x) => x.articulo.id === item.articuloId
            )
            if (index > -1) {
              const cantidades = [
                ...(cuenta.get(item.articuloId)?.cantidades || []),
                item.cantidad
              ]
              cuenta.set(item.articuloId, { index, cantidades })
            }
          })
        // Agregar items de folio y/o folio completo
        const index = state.folios.findIndex((x) => x.id === folio.id)
        if (index > -1) {
          state.folios[index].items = folio.items
        } else {
          state.folios.push(folio)
        }
      })
      // Actualizar cantidad contada
      for (const [, value] of cuenta) {
        state.items[value.index].cantidadContada = value.cantidades.reduce(
          (a, b) => a + b,
          0
        )
      }
      // Quitar folios filtrados
      state.folios = state.folios.filter((x) =>
        payload.map((y) => y.id).includes(x.id)
      )
    },
    TOGGLE_ITEM_REQUEST: (state, payload) => {
      state.folios = state.folios.map((item) => {
        if (item.id === payload.folioId) {
          const index = state.items.findIndex(
            (x) => x.articulo.id === payload.articuloId
          )
          if (index > -1)
            if (payload.valor)
              state.items[index].cantidadContada += payload.cantidad
            else state.items[index].cantidadContada -= payload.cantidad
          return { ...item, confirmado: payload.valor, loading: true }
        }
        return item
      })
    },
    TOGGLE_ITEM_SUCCESS: (state, payload) => {
      if (!payload.todos) {
        state.folios = state.folios.map((item) => {
          if (item.id === payload.folioId) {
            const index = state.items.findIndex(
              (x) => x.articulo.id === item.articuloId
            )
            if (index > -1)
              if (payload.valor)
                state.items[index].cantidadContada += item.cantidad
              else state.items[index].cantidadContada -= item.cantidad
            return { ...item, loading: false }
          }
          return item
        })
      }
    },
    SET_SCROLL_HORIZONTAL: (state, payload) => {
      state.scrollX = payload
    },
    CLOSE_RECUENTO_REQUEST: (state) => {
      state.estado = 'loading'
    },
    CLOSE_RECUENTO_SUCCESS: (state, payload) => {
      state.recuento = payload
    },
    ITEMS_COUNT_REQUEST: (state) => {
      state.totalItems = 0
      state.estado = 'loading'
    },
    ITEMS_COUNT_SUCCESS: (state, payload) => {
      state.totalItems = payload.totalFilas
    },
    SET_PAGE_SUCCESS: (state, payload) => {
      state.page = payload.page
    },
    SET_PAGE_SIZE_SUCCESS: (state, payload) => {
      state.pageSize = payload.pageSize
    },
    SET_BUSQUEDA_SUCCESS: (state, payload) => {
      state.busquedaFolio = payload.busquedaFolio ?? state.busquedaFolio
      state.busquedaArticulo =
        payload.busquedaArticulo ?? state.busquedaArticulo
    }
  },
  actions: {
    async loadInitialData({ commit, dispatch }, payload) {
      commit('INITIAL_DATA_REQUEST')
      await Promise.all([
        dispatch('loadRecuento', payload),
        dispatch('loadRecuentoItems', payload),
        dispatch('loadRecuentoFolios', payload),
        dispatch('loadRecuentoItemsCount', payload)
      ])
      commit('DATA_SUCCESS')
    },
    async updateData({ commit, dispatch }, payload) {
      commit('INITIAL_DATA_REQUEST')
      await Promise.all([
        dispatch('loadRecuentoItems', payload),
        dispatch('loadRecuentoFolios', payload),
        dispatch('loadRecuentoItemsCount', payload)
      ])
      commit('DATA_SUCCESS')
    },
    async loadRecuentoItems({ state, commit }, payload) {
      commit('ITEMS_REQUEST')
      const response = await inventarioService.getArticulosByRecuento(
        payload.recuentoId,
        state.page,
        state.pageSize,
        state.busquedaArticulo
      )
      commit('ITEMS_SUCCESS', response.data)
    },
    async loadRecuentoItemsCount({ state, commit }, payload) {
      commit('ITEMS_COUNT_REQUEST')
      const response = await inventarioService.getRecuentoMetadata(
        payload.recuentoId,
        state.busquedaArticulo
      )
      commit('ITEMS_COUNT_SUCCESS', response.data)
    },
    async loadRecuento({ commit }, payload) {
      commit('RECUENTO_REQUEST')
      const response = await inventarioService.getRecuento(payload.recuentoId)
      commit('RECUENTO_SUCCESS', response.data)
    },
    async loadRecuentoFolios({ state, commit }, payload) {
      commit('FOLIOS_REQUEST')
      const response = await inventarioService.getFoliosValidos(
        payload.recuentoId,
        state.page,
        state.pageSize,
        state.busquedaArticulo,
        state.busquedaFolio
      )
      commit('FOLIOS_SUCCESS', response.data)
    },
    async toggleFolioItem({ state, commit, dispatch }, payload) {
      commit('TOGGLE_ITEM_REQUEST', payload)
      await inventarioService.toggleFolioItem(
        payload.folioId,
        payload.articuloId,
        payload.valor,
        payload.todos
      )
      const folio = state.folios.findIndex((f) => f.id === payload.folioId)
      const items = state.folios[folio].items
      if (payload.todos) {
        items.forEach((_, index) => {
          items[index].confirmado = payload.valor
        })
      } else {
        state.folios[folio].confirmados = payload.valor
          ? state.folios[folio].confirmados + 1
          : state.folios[folio].confirmados - 1
        state.folios[folio].noConfirmados = !payload.valor
          ? state.folios[folio].noConfirmados + 1
          : state.folios[folio].noConfirmados - 1
        items.forEach((item, index) => {
          if (item.articuloId === payload.articuloId) {
            items[index].confirmado = payload.valor
          }
        })
      }
      state.folios[folio].items = items
      commit('TOGGLE_ITEM_SUCCESS', payload)
    },
    async closeRecuento({ state, commit }) {
      commit('CLOSE_RECUENTO_REQUEST')
      const response = await inventarioService.closeRecuento(state.recuento.id)
      commit('CLOSE_RECUENTO_SUCCESS', response.data)
    },
    async setComparadorPage({ state, dispatch, commit }, payload) {
      commit('SET_PAGE_SUCCESS', payload)
      await dispatch('updateData', { recuentoId: state.recuento.id })
    },
    async setPageSize({ state, dispatch, commit }, payload) {
      commit('SET_PAGE_SIZE_SUCCESS', payload)
      await dispatch('updateData', { recuentoId: state.recuento.id })
    },
    async setBusqueda({ state, dispatch, commit }, payload) {
      commit('SET_BUSQUEDA_SUCCESS', payload)
      await dispatch('updateData', { recuentoId: state.recuento.id })
    }
  }
}
